import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { ProjectResponse } from '../../lib'
import { GetProjectParams } from '@/shared/api/end-points/project'

const getone = async (params: GetProjectParams) => {
  return await api.json<ProjectResponse>(API_END_POINTS.project.getProject(params))
}

export default getone
